import {
  useContext,
  useReducer,
  createContext,
  useEffect,
  // useState,
} from "react";
import { shipReducer } from "../reducers/shipReducer";
import { ITEM_OPTIONS } from "../data/items";
import { useLocation } from "react-router-dom";
import { 
  // HYDRATE_DRAFT, 
  RESET_STATE } from "../reducers/types";

export const initialState = {
  step: 0,
  from: {
    isExistingAddress: undefined,
    shouldSaveAddress: undefined,
    existingAddress: {},
    name: "",
    address1: "",
    address2: "",
    city: "",
    state: {},
    country: {},
    zip: "",
    phone: "",
    email: "",
    autocompleteEnabled: false,
  },
  to: {
    name: "",
    address1: "",
    address2: "",
    city: "",
    state: {},
    country: {},
    zip: "",
    phone: "",
    email: "",
    autocompleteEnabled: false,
  },
  item: {
    isImperial: true,
    type: ITEM_OPTIONS[0],
    length: "",
    width: "",
    height: "",
    weight: "",
    insurance: false,
    value: "",
    invoiceCurrency: { id: "CAD", name: "CAD CA$" },
  },
  rates: [],
  selectedRate: {},
  orderId: null,
  validatedAddresses: {
    from: null,
    to: null,
  },
};

export const ShipContext = createContext(initialState);

// const STORAGE_KEY = "shipFormDraft";
// const ONE_DAY = 1000 * 60 * 60 * 24;

export const ShipProvider = ({ children }) => {
  const location = useLocation();
  // const [wasRestored, setWasRestored] = useState(false);

  const [state, dispatch] = useReducer(shipReducer, initialState);

  useEffect(() => {
    if (location.pathname !== "/dashboard/ship") {
      dispatch({
        type: RESET_STATE,
      });
    }
  }, [location]);

  // ---------------------------------
  // Restore Draft on Mount
  // ---------------------------------
  // useEffect(() => {
  //   if (location.pathname !== "/dashboard/ship") return;

  //   const saved = localStorage.getItem(STORAGE_KEY);
  //   if (!saved) return;

  //   try {
  //     const parsed = JSON.parse(saved);

  //     if (Date.now() - parsed.timestamp > ONE_DAY) {
  //       localStorage.removeItem(STORAGE_KEY);
  //       return;
  //     }

  //     dispatch({
  //       type: HYDRATE_DRAFT,
  //       payload: parsed,
  //     });

  //     setWasRestored(true);
  //   } catch (err) {
  //     localStorage.removeItem(STORAGE_KEY);
  //   }
  // }, [location.pathname]);

  // // ---------------------------------
  // // Persist Draft (safe slices only)
  // // ---------------------------------
  // useEffect(() => {
  //   if (location.pathname !== "/dashboard/ship") return;

  //   // Do NOT persist confirmation
  //   if (state.step === 5) {
  //     localStorage.removeItem(STORAGE_KEY);
  //     return;
  //   }

  //   const draft = {
  //     step: state.step,
  //     from: state.from,
  //     to: state.to,
  //     item: state.item,
  //     timestamp: Date.now(),
  //   };

  //   localStorage.setItem(STORAGE_KEY, JSON.stringify(draft));
  // }, [state.step, state.from, state.to, state.item, location.pathname]);

  return (
    <ShipContext.Provider
      value={{
        state,
        dispatch,
        // wasRestored
      }}
    >
      {children}
    </ShipContext.Provider>
  );
};

export const useShipContext = () => useContext(ShipContext);
